import { Action } from '@ngrx/store';

export class Info {
  private clinic: any = null;
  private treatment: any = null;
  private price: any = null;
  private practitioner: any = null;
  public  date: any = [];
  private time: any = null;
  private details: any = null;
  private data?: any = null;
  private type?: any = null;
  private token?: any = null;
  private customer?: any = null;
  private cardValidationProccess?: boolean = false;
}

export const INFO_UPDATE = 'INFO_UPDATE';
export const INFO_DATA_SEND = 'INFO_DATA_SEND';
export const INFO_DATA_SEND_PROCESSING = 'INFO_DATA_SEND_PROCESSING';
export const INFO_DATA_SEND_SUCCESS = 'INFO_DATA_SEND_SUCCESS';
export const INFO_DATA_SEND_FAILURE = 'INFO_DATA_SEND_FAILURE';
export const INFO_PAYMENT = 'INFO_PAYMENT';
export const INFO_PAYMENT_PROCESSING = 'INFO_PAYMENT_PROCESSING';
export const INFO_PAYMENT_SUCCESS = 'INFO_PAYMENT_SUCCESS';
export const INFO_PAYMENT_FAILURE = 'INFO_PAYMENT_FAILURE';

export class InfoAction implements Action {
  public type;

  constructor(
    public payload: Info
  ) {}
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/actions/info.action.ts